// API Helper for authenticated requests

const getApiKeyForUrl = (url) => {
  // Use siridharini API key for siridharini endpoints
  if (url && url.includes('/siridharini/')) {
    return process.env.REACT_APP_SIRIDHARINI_API_KEY;
  }
  // Use winnest API key for all other endpoints
  return process.env.REACT_APP_WINNEST_API_KEY;
};

const getAuthHeaders = (url) => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Add appropriate API key based on URL
  const apiKey = getApiKeyForUrl(url);
  if (apiKey) {
    headers['X-API-Key'] = apiKey;
  }
  
  return headers;
};

const getMultipartHeaders = (url) => {
  const token = localStorage.getItem('authToken');
  const headers = {};
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Add appropriate API key based on URL
  const apiKey = getApiKeyForUrl(url);
  if (apiKey) {
    headers['X-API-Key'] = apiKey;
  }
  
  // Don't set Content-Type for multipart/form-data
  // Browser will set it automatically with boundary
  
  return headers;
};

export const apiRequest = async (url, options = {}) => {
  const defaultOptions = {
    headers: getAuthHeaders(url),
  };
  
  const finalOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };
  
  const response = await fetch(url, finalOptions);
  
  // Don't handle 401 here, let the component handle it
  // The backend requires both API key and JWT for admin endpoints
  
  return response;
};

export const apiRequestMultipart = async (url, formData, options = {}) => {
  const finalOptions = {
    method: options.method || 'POST',
    headers: getMultipartHeaders(url),
    body: formData,
    ...options,
  };
  
  const response = await fetch(url, finalOptions);
  
  // Don't handle 401 here, let the component handle it
  // The backend requires both API key and JWT for admin endpoints
  
  return response;
};

export { getAuthHeaders, getMultipartHeaders, getApiKeyForUrl };